import Button from "../../../components/Button/Button";
import SortAscendingIcon from "../../../assets/svg/sort-ascending-icon";
import SortDescendingIcon from "../../../assets/svg/sort-descending-icon";
import CheckIcon from "../../../assets/svg/check-icon";
// import LeadScoreIcon from "../../../assets/svg/lead-score-icon";
// import RightArrowIcon from "../../../assets/svg/right-arrow-icon";
import { Stage } from "../utils/types";

const LeadStageSortPopup = ({
  stage,
  onSortChange,
  onClose,
}: {
  stage: Stage;
  onSortChange: (
    stageId: string,
    field: keyof Stage["filters"] | "reset",
    value?: 1 | -1,
  ) => void;
  onClose: () => void;
}) => {
  const sortField = stage.stage === "enquired" ? "created_at" : "updated_at";
  const currentSort =
    stage?.filters?.[sortField as keyof Stage["filters"]] ?? -1;
  // const leadScoreSort = stage?.filters?.lead_score ?? undefined;

  const handleSortChange = (
    field: keyof Stage["filters"] | "reset",
    value?: 1 | -1,
  ) => {
    if (field === "reset" && currentSort) {
      onSortChange(stage.stage, field);
      return;
    }
    if (value === stage?.filters?.[field as keyof Stage["filters"]]) {
      return;
    }
    onSortChange(stage.stage, field, value);
  };

  return (
    <div
      data-crm-popup-content
      className="absolute z-11 top-4 right-0 flex flex-col gap-4 w-max h-fit border border-border-gray dark:border-border-gray-dk rounded-[8px] p-3 bg-popper-bg dark:bg-popper-bg-dk shadow-popper-blur-effect backdrop-blur-2xl"
    >
      <div className="flex flex-col w-full">
        <div
          className={`w-full h-[34px] rounded-[8px] p-2  flex items-center gap-1 cursor-pointer ${
            currentSort === -1
              ? "bg-card-highlight dark:bg-card-highlight-dk"
              : "hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
          }`}
          onClick={() => {
            handleSortChange(sortField as keyof Stage["filters"], -1);
            onClose();
          }}
        >
          <SortAscendingIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
          <p className="text-md text-heading-text dark:text-heading-text-dk shrink-0">
            Newest First{" "}
            <span className="text-xxs text-gray-placeholder dark:text-gray-placeholder-dk">
              {stage.stage !== "enquired" ? "Recently Updated" : "(New Leads)"}
            </span>
          </p>
          {currentSort === -1 && (
            <CheckIcon className="ml-auto w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0" />
          )}
        </div>
        <div
          className={`w-full h-[34px] rounded-[8px] p-2  flex items-center gap-1 cursor-pointer ${
            currentSort === 1
              ? "bg-card-highlight dark:bg-card-highlight-dk"
              : "hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
          }`}
          onClick={() => {
            handleSortChange(sortField as keyof Stage["filters"], 1);
            onClose();
          }}
        >
          <SortDescendingIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
          <p className="text-md text-heading-text dark:text-heading-text-dk shrink-0">
            Oldest First{" "}
            <span className="text-xxs text-gray-placeholder dark:text-gray-placeholder-dk">
              {stage.stage !== "enquired" ? "Least Updated" : "(Old Leads)"}
            </span>
          </p>
          {currentSort === 1 && (
            <CheckIcon className="ml-auto w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0" />
          )}
        </div>

        {/* <hr className="w-full border-border-gray dark:border-border-gray-dk h-[1px] shrink-0 my-1.5" />

        <div
          className="w-full h-[34px] rounded-[8px] p-2 hover:bg-hover-effect dark:hover:bg-hover-effect-dk flex items-center gap-1"
          onClick={() => handleSortChange("lead_score", -1)}
        >
          <LeadScoreIcon className="w-[18px] h-[18px] text-analytics-yellow dark:text-analytics-yellow-dk shrink-0" />
          <p className="text-md flex items-center gap-0.5 text-heading-text dark:text-heading-text-dk shrink-0 whitespace-nowrap">
            <span>Lead Score: High</span>
            <RightArrowIcon className="w-[14px] h-[14px] text-verba-indigo dark:text-verba-indigo-dk" />{" "}
            <span>Low</span>
          </p>
          {leadScoreSort === -1 && (
            <CheckIcon className="ml-auto w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0" />
          )}
        </div>
        <div
          className="w-full h-[34px] rounded-[8px] p-2 hover:bg-hover-effect dark:hover:bg-hover-effect-dk flex items-center gap-1"
          onClick={() => handleSortChange("lead_score", 1)}
        >
          <LeadScoreIcon className="w-[18px] h-[18px] text-analytics-yellow dark:text-analytics-yellow-dk shrink-0" />
          <p className="text-md flex items-center gap-0.5 text-heading-text dark:text-heading-text-dk shrink-0 whitespace-nowrap">
            <span>Lead Score: Low</span>
            <RightArrowIcon className="w-[14px] h-[14px] text-verba-indigo dark:text-verba-indigo-dk" />{" "}
            <span>High</span>
          </p>
          {leadScoreSort === 1 && (
            <CheckIcon className="ml-auto w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0" />
          )}
        </div> */}
      </div>
      <Button
        innerText="Reset"
        buttonContainerClass="w-fit"
        onClick={() => {
          handleSortChange("reset");
          onClose();
        }}
        innerTextClass="text-verba-blue dark:text-verba-blue-dk text-md font-medium hover:underline"
      />
    </div>
  );
};

export default LeadStageSortPopup;
